import {getLocaleFolder} from './language';

async function importLocaleModule(folder, fileName) {
    return import(`../libs/${folder}/${fileName}`);
}

export async function loadLocaleExport({language, fileName, exportName, folderOverrides}) {
    const folder = getLocaleFolder(language, folderOverrides);

    try {
        const module = await importLocaleModule(folder, fileName);
        return module[exportName];
    } catch (error) {
        if (folder !== 'en') {
            const fallbackModule = await importLocaleModule('en', fileName);
            return fallbackModule[exportName];
        }
        throw error;
    }
}

export async function loadLocaleBundle(language, bundle) {
    const entries = await Promise.all(
        bundle.map(async ({key, fileName, exportName, folderOverrides}) => {
            const value = await loadLocaleExport({language, fileName, exportName, folderOverrides});
            return [key, value];
        })
    );

    return Object.fromEntries(entries);
}
